import React, { Component } from 'react';
import { Header, Image, Grid, } from 'semantic-ui-react'
import MainCard from './MainPageCards'
import * as Cards from './LandingPageCardsOrdering/MainCardsOrdering'
import * as UiConsts from '../../config/UiConstants'

import createBrowserHistory from 'history/createBrowserHistory';
import { getPrintValues, getMainCardObjects } from '../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
const history = createBrowserHistory({ forceRefresh: true });

export default class LandingPageCards extends Component {
    constructor(props) {
        super(props)

        this.state = ({
            loading:true,
            finalCardOrder: [],
            algoliaArray: [],
        })
    }

    getKeyByValue = (object, value) => {
        return Object.keys(object).find(key => object[key] === value);
    }



    fillMainCardArray = (firstCardKey) => {
        console.log("munx14 obx2 ++++++++++ fillMainCardArray");
        console.log("munx14 obx21 :this.props.specialEntry:" + this.props.specialEntry);
        //console.log("fmx101 firstCardKey:" + firstCardKey);


        // mainCardobjects.map((card) => {
        //     console.log("fmx12 inside loop with:"+card.itemType);
        // })

        //  console.log("fmx12 football:"+Cards.mainCardobjects["football"]);

        // Object.keys(Cards.mainCardobjects).forEach(function (key) {
        //     console.log("fmx12:" + key, Cards.mainCardobjects[key]);
        // });


        let tempArray = [];

        //DO NOT ADD FOOTBALL OR CRANES
        //REMOVE FOOTBALL AND CRANES.
        if (this.props.specialEntry && this.props.specialEntry == 'cranesFootball') {
            console.log("munx1 admin user keeping this..");
            //PUSH FIRST KEY
            tempArray.push(Cards.mainCardobjects[firstCardKey]);
        } else {
            //PUSH FIRST KEY
            if (firstCardKey != 'football' && firstCardKey != 'cranes') {
                tempArray.push(Cards.mainCardobjects[firstCardKey]);
            } else {
                console.log("munx12 - football or cranes and not admin")
            }

        }



        for (let value of Object.values(Cards.mainCardobjects)) {
            console.log("munx13 value['objectKey']:" + value['objectKey']);
            //console.log("fmx13:" + JSON.stringify(value, null, 3)); // John, then 30

            //IF ITS NOT THE FIRST KEY THEN ADD IT

            if (value['objectKey'] !== firstCardKey) {
                //console.log("fmx131 firstCardKey doesnot equal object key:"+value["objectKey"]);

                //IF USING THIS URL: http://localhost:3000/admin/cranesFootball.. 
                // CRANES FOOTBALL IS THE specialEntry PASSED FROM APP.JS
                // ONLY USING THAT URL CAN YOU ORDER CRANES OR FOOTBALL
                if (this.props.specialEntry && this.props.specialEntry == 'cranesFootball') {
                    console.log("munx1 this.props.specialEntry == 'cranesFootball' keeping this..");
                    //PUSH FIRST KEY
                    tempArray.push(value);
                } else {
                    //PUSH FIRST KEY
                    if (value['objectKey'] != 'football' && value['objectKey'] != 'cranes') {
                        tempArray.push(value);
                    } else {
                        console.log("munx12 - football or cranes and not admin")
                    }

                }


                //console.log("fmx14 tempArraySize:" + tempArray.length);
            } else {
                //console.log("fmx141 firstCardKey EQUALS object key:"+value['objectKey']);
            }

        }



        this.setState({
            finalCardOrder: tempArray
        })

    }

    //2. SET MAIN CARD OBJECTS
    setMainCardObjects = (objects) =>{
        console.log("obx1 +++++++:setMainCardObjects");
       // console.log("obx12 hits:"+JSON.stringify(objects, null, 3));
        this.setState({
            algoliaArray:objects
        })

        this.newFillOrderArray(objects);
    }

    // 3. CHECK FOR FIRST CARD KEY
    newFillOrderArray = (objects) =>{
        console.log("obx3 +++++++:newFillOrderArray");
        console.log("obx31 firstCardKey:"+this.props.firstCardKey);

        let newTempArray = [];

        // IF FIRST CARD KEY EXISTS ADD ITEM TO VALUE
        if(this.props.firstCardKey){
            //GET THE ITEM PASSED IN THE URL BEING VISITED TO MAKE IT TEH FIRST ITEM..
            // E.G. http://localhost:3000/fb/t_shirts/adset/t_shirts -- THE ITEM AFTER FB/ IN THIS EXAMPLE t_shirts
            // THE T SHIRTS OBJECT FROM ALGOLIA ARRA IS ADDED FIRST TO TEMP ARRAY TO AFFECT THE ORDER IN WHICH CARDS APPEAR TO THE USER..
            console.log("obx32 firstCardKeyExists:");
            console.log("obx34 find objects.find(x => x.itemType === 'itemType'):"+JSON.stringify(objects.find(x => x.objectKey === this.props.firstCardKey), null, 3));

            newTempArray.push(objects.find(x => x.objectKey === this.props.firstCardKey));
            console.log("obx35 first item added:"+newTempArray.length);
        }

        //ADD OTHER ITEMS TO LIST
        for (let value of Object.values(objects)) {
           // console.log("obx36 adding new value:"+JSON.stringify(value, null, 3));
            console.log("obx36 adding new value:"+value.objectKey);

            //DON'T ADD FIRST CARD VALUE
            if(value.objectKey !== this.props.firstCardKey && !value.restricted){
                console.log("obx37 this.props.firstCardKey && value.objectKey !== firstCardKey")
                newTempArray.push(value);

                    // add cranes and football if they are using special url http://localhost:3000/admin/cranesFootball
            }else if(value.objectKey !== this.props.firstCardKey && value.restricted && this.props.specialEntry){
                console.log("obx37 this.props.firstCardKey && value.objectKey !== firstCardKey")
                newTempArray.push(value);
            }else{
                
                console.log("obx38 firstcard key object not inserting:"+value.objectKey);
            }
        }

        console.log("obx39 final temp array size:"+newTempArray.length);

        this.setState({
            finalCardOrder: newTempArray,
            loading:false
        })
    }

    componentDidMount() {

        //1. GET MAIN CARD OBJECTS FROM ALGOLIA
        getMainCardObjects("mainCardObjects", this.setMainCardObjects);

        // if (this.props.firstCardKey) {
        //     this.fillMainCardArray(this.props.firstCardKey);
        // } else {
        //     this.fillMainCardArray("t_shirts");
        // }

        //CHECK FOR ADMIN URL: http://localhost:3000/admin/cranesFootball
        // if(this.props.specialEntry){
        //     this.checkUser();
        // }

    }

    
    render() {

        const landingCardsArray = this.state.finalCardOrder.map((card) =>
            <Grid.Column>
                <MainCard
                    image={card.image}
                    imageSize={card.imageSize}
                    itemTypeDescription={card.itemTypeDescription}
                    itemType={card.itemType}
                    fullDescription={card.fullDescription}
                    shortDescriptions={card.shortDescriptions}
                    showMainForm={this.props.showMainForm}
                    template={true}
                    templateType={card.templateType}
                    cardObject={card}
                    adset={this.props.adset} 
                    admin={this.props.admin}/>
            </Grid.Column>
        )

        return ( this.state.loading === true ? <UiConsts.LoadingComponent /> : 
            <div>
                {/* CLOSURE */}
                <Image src={require('../../images/printboda_logo.png')} />
                {/* <Image centered src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/closureNotices%2FPrintboda%20-%20covid%20-%20closed_5_siteImage-min.jpg?alt=media&token=432231de-4ede-40dc-a04d-701aa9e58cfa' /> */}

                <Header as='h2' color='blue' textAlign='center' >
                    <Header.Subheader>
                        0757477399
                </Header.Subheader>
                    <Header.Subheader>
                        Suite A1 2nd Flr, Mbogo Road 1, Najerra 1
                </Header.Subheader>
                    <Header.Subheader>
                        <a href="https://goo.gl/maps/NNELqcoZSau" target="_blank"> VIEW ADDRESS ON GOOGLE MAPS</a>
                    </Header.Subheader>
                    <Header.Subheader>
                        <a href="mailto:info@printboda.com"> info@printboda.com</a>
                    </Header.Subheader>
                </Header>

                <Header as='h2' color='blue' textAlign='center' >
                    Select A Service
                    <Header.Subheader>
                        What Item can we make for you? (Scroll down to see all options)
                </Header.Subheader>
                </Header>

                <Grid container stackable columns={3}>

                    {landingCardsArray}
                </Grid>





            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/LandingPageCards.js